import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class InTeamLevelService {

  public inTeamLevel = new BehaviorSubject<Number>(0);

  constructor() { }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/in-team-level.service.ts